module.exports = __webpack_public_path__ + "img/office-chat.e5944bb9.svg";